import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import { apiAdminConfig } from '../../utils/api';

const MultiPDFBox = (props) => {
    const { name, label, error, isValid, disabled, placeholder, required, value, className, accept, isEdit = false, fileError, setFileError, uploadText="Upload Certificate PDF" } = props;
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [errors, setErrors] = React.useState('');
    const fileRef = React.useRef(null);

    const fileUpload = async (e) => {
        setMessage('');
        setErrors('');
        let file = e.target.files[0];
        const MAX_FILE_SIZE = 4096 // 4MB
        const apiCall = [];
        const formData = new FormData();
        Object.values(e?.target?.files).forEach((value) => {
            const fileSizeKiloBytes = value?.size / 1024;
            if (!(fileSizeKiloBytes > MAX_FILE_SIZE)) {
                formData.append(`file`, value);
                apiCall?.push(true)
            } else {
                apiCall?.push(false)
            }
        });
        setLoading(true);

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        await apiAdminConfig.post(`/${props.url}`, formData, config).then((response) => {
            const { data } = response;
            if (response.status) {
                setLoading(false);
                setMessage(data.message);
                props.onChange(data?.data?.map(list => ({
                    url: list?.Location,
                })) ?? []);
            } else {
                setLoading(false);
                setErrors(data.message);
            }
        }).catch((error) => {
            console.log('error', error);
            const { response } = error;
            setLoading(false);
            if (response) {
                setErrors(response.data.message);
                setTimeout(() => {
                    setErrors('');
                }, 4000);
            }

        });
    };

    return (
        <>
            <input
                style={{ display: 'none' }}
                id="document-file"
                ref={fileRef}
                type="file"
                multiple
                accept={accept}
                onChange={(e) => {
                    setFileError(false)
                    fileUpload(e);
                    e.target.value = null;
                }}
            />
            <Form.Group className="position-relative mb-3">
                <Form.Label htmlFor="announcementsImage_id">
                    {label} <br />
                    <Button
                        variant="contained"
                        htmlFor="document-file"
                        color="primary"
                        component="span"
                        onClick={() => fileRef.current.click()}
                        className="input_file_button"
                    >
                        {loading ? <Spinner /> :uploadText}
                    </Button>
                    <p style={{
                        margin: '5px 0 0 0',
                        color: '#8b7c7c'
                    }}>Upload Maximum 4mb file.</p>
                </Form.Label>
                <Form.Control
                    hidden
                    type='url'
                    disabled={disabled}
                    required={required}
                    value={value}
                    placeholder={placeholder}
                    name={name}
                    onChange={e => props.onChange(e.target.value)}
                    isValid={isValid}
                    isInvalid={error}
                />
                {fileError ? <p style={{
                    margin: 0,
                    marginTop: '0.25rem',
                    fontSize: '.875em',
                    color: '#dc3545'
                }}>File is a required</p> : ""}

            </Form.Group>
        </>
    );
};

export default MultiPDFBox;